// extracted by mini-css-extract-plugin
export var quantityInput = "_pr-0";